<div class="authentication blank-layout-container justify-content-center align-items-center ">
    <div class="position-relative row w-100 h-100 bg-gredient justify-content-center">
        <div class="col-lg-4 col-md-6 col-sm-8 d-flex align-items-center">
            <mat-card class="cardWithShadow boxed-auth">
                <mat-card-content class="p-32 m-t-20 ">
                    <h2 style="text-align: center;">{{"SERVICE_NAME" | translate}} お問い合わせ</h2>
                    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="m-t-30">

                        <div *ngIf="!submited">

                            <p class=" p-b-20 " [innerHTML]="'MESSAGES.CONTACT_DESCRIPTION' | translate">
                            </p>

                            <mat-form-field appearance="outline" class="w-100 p-b-10 " color="primary">
                                <mat-label>メールアドレス</mat-label>
                                <input matInput type="email" formControlName="email" required>
                                <mat-error *ngIf="form.get('email')?.hasError('required')">
                                    メールアドレスは必須です
                                </mat-error>
                                <mat-error *ngIf="form.get('email')?.hasError('email')">
                                    メールアドレスの形式が正しくありません
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100 p-b-10 " color="primary">
                                <mat-label>件名</mat-label>
                                <input matInput formControlName="subject" required>
                                <mat-error *ngIf="form.get('subject')?.hasError('required')">
                                    件名は必須です
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100 p-b-10 " color="primary">
                                <mat-label>お問い合わせ内容</mat-label>
                                <textarea matInput formControlName="message" rows="6" required></textarea>
                                <mat-error *ngIf="form.get('message')?.hasError('required')">
                                    お問い合わせ内容は必須です
                                </mat-error>
                            </mat-form-field>

                            <button mat-button color="primary" [disabled]="form.invalid || submitting">
                                送信
                            </button>
                        </div>

                        <div *ngIf="submited">

                            <p class=" p-b-20 " [innerHTML]="'MESSAGES.CONTACT_SUBMITED' | translate">
                            </p>

                        </div>
                    </form>

                </mat-card-content>
            </mat-card>

        </div>

    </div>
</div>